import React from 'react';
import Layout from '../components/Layout/Layout';
import Seo from '../components/Seo/Seo';
import PharmaciesSite from '../components/PharmaciesSite/PharmaciesSite';
import COS_FOOTER_SANTE from '../images/COS_FOOTER_SANTE.jpg';

const Partenaires = () => {
  return (
    <Layout logo={COS_FOOTER_SANTE}>
      <Seo title="COS - Pharmacies" description="COS - Pharmacies" />
      <PharmaciesSite />
    </Layout>
  );
};

export default Partenaires;
